module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-15-b241eb90ba82a2aac638751cd4bdce9b.png";